import _inject from "@stylexjs/stylex/lib/stylex-inject";
var _inject2 = _inject;
import type { ReactNode } from "react";
import * as stylex from "@stylexjs/stylex";
export function SectionKicker({
  icon,
  children
}: {
  icon?: ReactNode;
  children: ReactNode;
}) {
  const iconProps = {
    className: "x78zum5 x1xvt488 xf08kfj x2lah0s x6s0dn4 xl56j7k"
  };
  return <div className="x3nfvp2 x6s0dn4 xpraio3 xeq5yr9 x1e6avla xmkeg23 x1y0btm7 x1rwil0i x1xyz1i3 x1x0aavu xmjv5ib x1tt96h8 x1iuv88s x1xlr1w8 x11fj6oh xtvhhri">
      {icon ? <span {...iconProps} className={`${iconProps.className} section-kicker-icon`}>
          {icon}
        </span> : null}
      {children}
    </div>;
}
_inject2({
  ltr: ".x3nfvp2{display:inline-flex}",
  priority: 3000
});
_inject2({
  ltr: ".x6s0dn4{align-items:center}",
  priority: 3000
});
_inject2({
  ltr: ".xpraio3{gap:.55rem}",
  priority: 2000
});
_inject2({
  ltr: ".xeq5yr9{width:fit-content}",
  priority: 4000
});
_inject2({
  ltr: ".x1e6avla{border-radius:999px}",
  priority: 2000
});
_inject2({
  ltr: ".xmkeg23{border-width:1px}",
  priority: 2000
});
_inject2({
  ltr: ".x1y0btm7{border-style:solid}",
  priority: 2000
});
_inject2({
  ltr: ".x1rwil0i{border-color:color-mix(in oklch,var(--accent) 20%,var(--surface-border))}",
  priority: 2000
});
_inject2({
  ltr: ".x1xyz1i3{background-color:color-mix(in oklch,var(--surface-2) 92%,var(--secondary))}",
  priority: 3000
});
_inject2({
  ltr: ".x1x0aavu{color:color-mix(in oklch,var(--foreground) 78%,var(--primary))}",
  priority: 3000
});
_inject2({
  ltr: ".xmjv5ib{padding-block:.45rem}",
  priority: 2000
});
_inject2({
  ltr: ".x1tt96h8{padding-inline:.9rem}",
  priority: 2000
});
_inject2({
  ltr: ".x1iuv88s{font-size:.72rem}",
  priority: 3000
});
_inject2({
  ltr: ".x1xlr1w8{font-weight:700}",
  priority: 3000
});
_inject2({
  ltr: ".x11fj6oh{letter-spacing:.18em}",
  priority: 3000
});
_inject2({
  ltr: ".xtvhhri{text-transform:uppercase}",
  priority: 3000
});
_inject2({
  ltr: ".x78zum5{display:flex}",
  priority: 3000
});
_inject2({
  ltr: ".x1xvt488{width:.875rem}",
  priority: 4000
});
_inject2({
  ltr: ".xf08kfj{height:.875rem}",
  priority: 4000
});
_inject2({
  ltr: ".x2lah0s{flex-shrink:0}",
  priority: 3000
});
_inject2({
  ltr: ".xl56j7k{justify-content:center}",
  priority: 3000
});